const DEFAULT_BOOK = {
  data: {
    title: 'Your StoryTerrace Book Title',
    authorName: 'Author name',
    backCoverText: '',
  },
  limits: {
    title: 55,
    subTitle: 130,
    authorName: 40,
    backCoverText: 750,
    styleSampleTitle: 80,
    styleSampleContent: 10000,
  },
};

export default DEFAULT_BOOK;
